import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["error"];
import React from 'react';
import { intrinsicComponent } from '../../utils/functions';
import Styled from './form-hint.styles';
var FormHint = intrinsicComponent(function (_ref, ref) {
  var _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Styled.FormHint, _extends({
    ref: ref,
    $error: error
  }, rest));
});
export default FormHint;